<template>
  <div class="event">
    <div class="pay">
      <Header :name="providerInfo.name" :min="_.isNull(bank) ? '' : bank.limits.min_payin" :max="_.isNull(bank) ? '' : bank.limits.max_payin" currency="TRY" />
      <form class="app-pay-form" @submit.prevent="send">
          <div class="col">
            <div class="inline-form">
              <label>Banka Hesapları</label>
              <select v-model="form.bank_id" class="form-control input-sm">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(in_bank,key) in banks" :key="key" :value="in_bank.id">{{ in_bank.name }}</option>
              </select>
            </div>
          </div>
          <div class="col" v-if="isVerifyPhone">
            <div class="inline-form">
              <div class="alert alert-success alert-pay animated pulse" v-if="!_.isNull(bank)">
                  <div class="alert-items" v-if="!_.isNull(bank.owner)"><b>Hesap Sahibi:</b> {{ bank.owner }} </div> 
                  <div class="alert-items" v-if="!_.isNull(bank.iban)"><b>IBAN:</b> {{ bank.iban }} </div> 
                  <div class="alert-items" v-if="!_.isNull(bank.account_code)"><b>Hesap Numarası:</b> {{ bank.account_code }} </div> 
                  <div class="alert-items" v-if="!_.isNull(bank.branch_code)"><b>Şube Kodu:</b> {{ bank.branch_code }} </div> 
              </div>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Açıklama</label>
              <input type="text" placeholder="Ek notunuz var ise yazınız" v-model="form.note">
            </div>
          </div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Yatır'" />
          </div>
          <div class="col">
            <div class="alert alert-danger" style="width: 100%; margin-top: 10px; padding:13px 0">
              <b>Lütfen Canlı Destek üzerinden güncel hesap talep ediniz.</b> Yatırım formunu doldururken gönderim sağlamış olduğunuz bankayı seçiniz.
            </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form:{
          name: _.get(this.$store.getters['auth/user'], 'full_name', null),
          bank_id: null,
          currency: 'TRY',
          amount: null,
          note: null,
          bonus_id: 0,
        },
        loading: false,
        btnLoading: false,
        banks: null,
        bank: null,
        min_pay: null,
        max_pay: null,
      }
    },
    created(){
      this.fetchData();
    },
    computed:{
      userDetail(){
          return this.$user_detail();
      },
      isVerifyPhone(){
        return !_.isUndefined(this.userDetail.detail.validations.phone) && this.userDetail.detail.validations.phone.r == 1 && this.userDetail.detail.validations.phone.s == 1;
      }
    },
    methods:{
      fetchData() {
        axios.get('/user/wallet/deposit/bank/list')
        .then((response) => {
          this.banks 	  = response.data.list;
        })
        .catch((err) => {
        })
      },
      send(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/deposit/bank/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      }
    },
    watch: {
      'form.bank_id': function(bank_id) {
        this.bank = _.find(this.banks, {"id": bank_id});
      }
    },
    components:{
      Header,
      Form
    }
  }

</script>
<style scoped lang="scss">
  .alert-items{
    font-size: 14px;
    margin: 1px 0;
    b{
      color: var(--client-c3);
    }
  }
  .alert-pay{
    border: 1px solid rgb(255 255 255 / 25%);
    text-align: left;
  }
</style>